export function roundToDecimals(x: number, decimals: number): number {
  return (
    Math.round((x + Number.EPSILON) * Math.pow(10, decimals)) /
    Math.pow(10, decimals)
  );
}
